import { EventBus } from '@/services/event-bus'

export default {
	methods: {
		saveSettings () {
			EventBus.$emit('update-widget', {
				unique: this.widget.unique,
				setup: true,
				settings: this.settings
			})
		},
		closeDialog () {
			EventBus.$emit('close-settings')
		}
	}
}
